import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import BasicTable from "../../components/UiComponent/customTable";
import {
  get_branch_employee_stock,
  get_branchstock,
  RegisterEmployeeStock,
  EmployeeStockSell,
} from "../../services/projectApi";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { GetUserInfo } from "../../utils/permissionChecker";
import { get_employee_data } from "../../services/employeeApi";
import { toast } from "react-toastify";
import { Modal, Row, Form, Col, Button, Spinner } from "react-bootstrap";

const EmployeeStockManagment = () => {
  const { t } = useTranslation();
  const user = GetUserInfo();
  const currentUser =
    user.employee.first_name + " " + user.employee.father_name;
  const user_branch = user?.employee?.branch_id;
  const queryClient = useQueryClient();
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => {
    setShowModal(true);
    setFormError("");
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setIsUpdateMode(false);
  };
  const [formError, setFormError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const RegisterEmployeeStockMutation = useMutation(async (newData) => {
    try {
      let result;
      if (isUpdateMode) {
        result = await EmployeeStockSell(newData);
      } else {
        result = await RegisterEmployeeStock(newData);
      }
      if (result) {
        queryClient.invalidateQueries("get_branch_employee_stock");
        toast.success(result.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        handleCloseModal();
      }
    } catch (error) {
      toast.error(error.message, {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  });

  const [formData, setFormData] = useState({
    item_id: "",
    employee_id: "",
    quantity: "",
    branch_id: user_branch,
    reference_id: "",
  });

  const { data, isLoading, isError, error } = useQuery(
    ["get_branch_employee_stock"],
    async () => {
      const employeeStock = await get_branch_employee_stock(user_branch);
      const branchStock = await get_branchstock(user_branch);
      const employeeData = await get_employee_data();
      return {
        employeeStock: employeeStock.data,
        branchStock: branchStock.data,
        employeeData: employeeData,
      };
    }
  );

  const filteredEmployeeData = useMemo(() => {
    const employeeData = data?.employeeData || [];

    if (!Array.isArray(employeeData)) return [];

    if (user.accessRole === "administrator") return employeeData;

    if (user.accessRole === "manager") {
      return employeeData.filter(
        (emp) => emp.branch_id === user?.employee?.branch_id
      );
    }

    return employeeData.filter((emp) => emp.id === user?.employee?.id);
  }, [data]);
  const stockData = useMemo(() => {
    return data?.employeeStock || [];
  }, [data]);

  const BranchstockData = useMemo(() => {
    return data?.branchStock || [];
  }, [data]);

  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (isError) {
    return <div>Error: {error.message}</div>;
  }

  const Update = (event, data) => {
    event.preventDefault();
    setIsUpdateMode(true);
    handleShowModal();
    formData.employee_id = data.employee_id;
    formData.item_id = data.item_id;
    formData.reference_id = data.id;
  };
  const handleButtonSubmit = async (e) => {
    e.preventDefault();
    if (!formData.item_id || !formData.employee_id || !formData.branch_id) {
      setFormError("Pease fill all fields are required ");
      return;
    }
    try {
      setIsSubmitting(true);
      await RegisterEmployeeStockMutation.mutate(formData);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleInputChange = (e, fieldName) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
  };
  const stockTableColumns = [
    {
      header: "name",
      accessorKey: "employee_name",
    },
    {
      header: "item",
      accessorKey: "item_name",
    },
    {
      header: "quantity",
      accessorKey: "current_quantity",
    },
    {
      header: "Action",
      accessor: "id",
      cell: (row) => (
        <div className="d-flex justify-content align-items-center">
          <Button
            variant="btn btn-info btn-sm"
            onClick={(e) => Update(e, row.row.original)}
          >
            {t("add sell")}
          </Button>
        </div>
      ),
    },
  ];
  return (
    <>
      <BasicTable
        data={stockData}
        columns={stockTableColumns}
        title={`Employee Stock Managment`}
        actionButton={
          <Button
            variant="btn btn-info btn-sm"
            onClick={() => handleShowModal()}
          >
            {t("add_stock")}
          </Button>
        }
      />
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered={true}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title as="h5">
            {isUpdateMode ? "Add new sell report" : "Add employee stock "}{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col lg="12">
                <Form.Group>
                  <div className="col-md-12 mb-3">
                    <Form.Label
                      htmlFor="inputPosition"
                      className="font-weight-bold text-muted"
                    >
                      {t("employee")}
                    </Form.Label>
                    <select
                      id="inputPosition"
                      className="form-select form-control choicesjs"
                      value={formData.employee_id}
                      onChange={(e) => handleInputChange(e, "employee_id")}
                    >
                      <option value="" hidden disabled>
                        Select Employee
                      </option>
                      {filteredEmployeeData.map((data) => (
                        <option key={data.id} value={data.id}>
                          {data.first_name} {data.father_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-12 mb-3">
                    <Form.Label
                      htmlFor="inputPosition"
                      className="font-weight-bold text-muted"
                    >
                      {t("item")}
                    </Form.Label>
                    <select
                      id="inputPosition"
                      className="form-select form-control choicesjs"
                      value={formData.item_id}
                      onChange={(e) => handleInputChange(e, "item_id")}
                    >
                      <option value="" hidden disabled>
                        Select Item
                      </option>
                      {BranchstockData?.map((data) => (
                        <option key={data.item_id} value={data.item_id}>
                          {data.item_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-12 mb-3">
                    <Form.Label className="text-secondary">Quantity</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter quantity"
                      value={formData.quantity}
                      onChange={(e) => handleInputChange(e, "quantity")}
                    />
                  </div>
                  <p className="text-danger"> {formError}</p>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          {isSubmitting ? (
            <Button className="btn btn-info">
              <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
              />
              <span className="visually-hidden">Sending...</span>
            </Button>
          ) : (
            <Button
              className="btn btn-info"
              onClick={(e) => handleButtonSubmit(e)}
            >
              {isUpdateMode ? "Add" : "Register"}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EmployeeStockManagment;
